// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"2":"b40725a9","594":"e9e480fb","804":"7ac82d49"}[chunkId] + ".js";
};